// Section Connection Reveal
if (window.innerWidth <= 768) {
    const connectors = document.querySelectorAll('.section-connector');
    connectors.forEach(conn => {
        ScrollTrigger.create({
            trigger: conn,
            start: "top 95%",
            onEnter: () => conn.classList.add('revealed')
        });
    });
}

// ==========================
// Hero Section JS
// Shopify Safe Version
// ========================== 

document.addEventListener("DOMContentLoaded", () => {

    function initStars(containerId, count = 40) {
        const starfield = document.getElementById(containerId);

        if (!starfield) return;

        for (let i = 0; i < count; i++) {

            const star = document.createElement("div");

            star.className = "twinkle-star";

            const size = Math.random() * 2 + 1;

            star.style.width = `${size}px`;
            star.style.height = `${size}px`;

            star.style.left = `${Math.random()*100}%`;
            star.style.top = `${Math.random()*100}%`;

            star.style.animationDelay=`${Math.random()*5}s`;

            if(Math.random() > 0.7){

                star.style.background="var(--warm-gold)";
                star.style.boxShadow="0 0 10px var(--warm-gold)";

            }else{

                star.style.boxShadow="0 0 8px white";

            }

            starfield.appendChild(star);

        }
    }

    initStars("starfield",40);


    const observer = new IntersectionObserver((entries)=>{

        entries.forEach(entry=>{

            if(entry.isIntersecting){

                entry.target.classList.add("visible");

            }

        });

    },{

        threshold:0.15

    });

    document.querySelectorAll(".reveal").forEach(el=>{

        observer.observe(el);

    });

    if(window.lucide){

        lucide.createIcons();

    }

});


let currentViewIndex = 0;

function switchHeroView(index){

    currentViewIndex=index;

    const thumbnails=document.querySelectorAll(".hero-thumbnail");

    const dots=document.querySelectorAll(".gallery-dot");

    const views=document.querySelectorAll(".gallery-view");

    thumbnails.forEach((thumb,i)=>{

        thumb.classList.toggle(
            "active",
            i===index
        );

    });

    dots.forEach((dot,i)=>{

        dot.classList.toggle(
            "active",
            i===index
        );

    });

    views.forEach((view,i)=>{

        view.classList.toggle(
            "active",
            i===index
        );

    });

}



function moveGallery(step){

    const totalViews=document.querySelectorAll(
        ".gallery-view"
    ).length;

    if(totalViews===0) return;

    let nextIndex=currentViewIndex+step;

    if(nextIndex>=totalViews){

        nextIndex=0;

    }

    if(nextIndex<0){

        nextIndex=totalViews-1;

    }

    switchHeroView(nextIndex);

}


function selectPack(
    index,
    price,
    oldPrice,
    element,
    variantId
){

    document
    .querySelectorAll(".pack-option")
    .forEach(item=>{

        item.classList.remove(
            "active"
        );

    });

    element.classList.add(
        "active"
    );


    const currentPrice=
    document.getElementById(
        "current-price"
    );

    const oldPriceEl=
    document.getElementById(
        "old-price"
    );

    const ctaPrice=
    document.getElementById(
        "cta-price"
    );

    if(currentPrice){

        currentPrice.innerText=
        `₹${price}`;

        currentPrice.style.transform=
        "scale(1.1)";

        setTimeout(()=>{

            currentPrice.style.transform=
            "scale(1)";

        },200);

    }

    if(oldPriceEl){

        oldPriceEl.innerText=
        oldPrice ?
        `₹${oldPrice}` :
        "";

    }

    if(ctaPrice){

        ctaPrice.innerText=
        `₹${price}`;

    }

    const selectedVariant=
    document.getElementById(
        "selectedVariant"
    );

    if(selectedVariant){

        selectedVariant.value=
        variantId;

    }

}






let hotspotCtx;

function initHotspots() {
    gsap.registerPlugin(ScrollTrigger);

    const section = document.querySelector("#features-hotspot-section");
    if (!section) return;

    const wrapper = section.querySelector(".hotspot-sticky-wrapper");

    if (hotspotCtx) {
        hotspotCtx.revert();
    }

    hotspotCtx = gsap.context(() => {
        let mm = gsap.matchMedia();

        // DESKTOP
        mm.add("(min-width: 768px)", () => {
            gsap.set(".hotspot-node", { opacity: 0, scale: 0.8 });
            
            document.querySelectorAll(".hotspot-connector").forEach(line => {
                const side = line.getAttribute("data-side");
                gsap.set(line, { 
                    scaleX: 0, 
                    opacity: 0, 
                    transformOrigin: side === "left" ? "right center" : "left center" 
                });
            });

            // Reduced end distance to 500 for a shorter scroll runtime
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: wrapper,
                    start: "top top",
                    end: "+=500", 
                    scrub: 0.5,
                    pin: true,
                    anticipatePin: 1,
                    invalidateOnRefresh: true
                }
            });

            // Fixed handling for the product visibility state
            tl.fromTo(".central-product-image", 
                { opacity: 0, scale: 0.7 },
                { opacity: 1, scale: 1, duration: 0.4, ease: "power2.out" }
            );

            document.querySelectorAll(".hotspot-node").forEach((node, index) => {
                const lineId = `#line-${index + 1}`;
                
                tl.to(lineId, {
                    scaleX: 1,
                    opacity: 1,
                    duration: 0.3,
                    ease: "power1.inOut"
                })
                .to(node, {
                    opacity: 1,
                    scale: 1,
                    duration: 0.3,
                    ease: "back.out(1.2)"
                }, "-=0.15");
            });
            
            tl.to({}, { duration: 0.1 });
        });

        // MOBILE
        mm.add("(max-width: 767px)", () => {
            gsap.set(".central-product-image", { opacity: 1, scale: 1 });
            
            document.querySelectorAll(".hotspot-node").forEach((node) => {
                gsap.fromTo(node, 
                    { opacity: 0, y: 20 },
                    {
                        opacity: 1,
                        y: 0,
                        duration: 0.5,
                        scrollTrigger: {
                            trigger: node,
                            start: "top 85%",
                            toggleActions: "play none none none"
                        }
                    }
                );
            });
        });

    }, section);
}

window.addEventListener("DOMContentLoaded", initHotspots);
window.addEventListener("load", () => { ScrollTrigger.refresh(); });